import { connect } from 'react-redux'

const IdentityServerCallback = (props) => {
  return null
}

export default connect()(IdentityServerCallback)
